// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policy-page {
  width: 100%;
  min-height: 100vh;
  background: #121212;
  color: #f1f1f1;
  font-family: "Satoshi", sans-serif;
}

.policy-section {
  width: 100%;
  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);
  max-width: 800px;
  margin: 0 auto;
}

.policy-title {
  text-align: center;
  font-size: clamp(32px, 4vw, 44px);
  font-weight: 600;
  margin: 0 0 24px;
  color: #f1f1f1;
  line-height: 1.25;
}

.policy-intro {
  text-align: center;
  font-size: clamp(15px, 1.5vw, 17px);
  line-height: 1.6;
  color: #a0a0a0;
  margin: 0 0 48px;
}

.policy-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.policy-block {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 28px;
  transition: border-color 0.2s ease;
}

.policy-block:hover {
  border-color: rgba(255, 255, 255, 0.16);
}

.policy-heading {
  font-size: clamp(18px, 1.8vw, 20px);
  font-weight: 600;
  color: #ccff00;
  margin: 0 0 12px;
  line-height: 1.3;
}

.policy-block p {
  font-size: clamp(14px, 1.2vw, 16px);
  line-height: 1.65;
  color: #a0a0a0;
  margin: 0 0 12px;
}

.policy-block p:last-child {
  margin-bottom: 0;
}

.policy-block ul {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
}

.policy-block li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 8px;
  font-size: clamp(14px, 1.2vw, 16px);
  line-height: 1.6;
  color: #a0a0a0;
}

.policy-block li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ccff00;
  font-weight: 700;
}

.policy-block li:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/policy/policy.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".policy-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #121212;\n  color: #f1f1f1;\n  font-family: \"Satoshi\", sans-serif;\n}\n\n.policy-section {\n  width: 100%;\n  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.policy-title {\n  text-align: center;\n  font-size: clamp(32px, 4vw, 44px);\n  font-weight: 600;\n  margin: 0 0 24px;\n  color: #f1f1f1;\n  line-height: 1.25;\n}\n\n.policy-intro {\n  text-align: center;\n  font-size: clamp(15px, 1.5vw, 17px);\n  line-height: 1.6;\n  color: #a0a0a0;\n  margin: 0 0 48px;\n}\n\n.policy-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.policy-block {\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px 28px;\n  transition: border-color 0.2s ease;\n}\n\n.policy-block:hover {\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\n.policy-heading {\n  font-size: clamp(18px, 1.8vw, 20px);\n  font-weight: 600;\n  color: #ccff00;\n  margin: 0 0 12px;\n  line-height: 1.3;\n}\n\n.policy-block p {\n  font-size: clamp(14px, 1.2vw, 16px);\n  line-height: 1.65;\n  color: #a0a0a0;\n  margin: 0 0 12px;\n}\n\n.policy-block p:last-child {\n  margin-bottom: 0;\n}\n\n.policy-block ul {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n}\n\n.policy-block li {\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 8px;\n  font-size: clamp(14px, 1.2vw, 16px);\n  line-height: 1.6;\n  color: #a0a0a0;\n}\n\n.policy-block li::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #ccff00;\n  font-weight: 700;\n}\n\n.policy-block li:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
